module.exports = __webpack_public_path__ + "static/media/Level_3.f295c9d2.png";